import styled from 'styled-components';

export const MainBlock = styled.div`
  overflow: hidden;
  flex: 1 0 auto;
  width: 100%;
  height: 100%;
  align-items: stretch;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px;
`;
export const BodyBlock = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const ListsWrapper = styled.div`
  height: 100%;
  overflow-y: auto;
`;
